import { render, staticRenderFns } from "./ClientProjectsEditDetailsStep8.vue?vue&type=template&id=88a2e50e&"
import script from "./ClientProjectsEditDetailsStep8.vue?vue&type=script&lang=js&"
export * from "./ClientProjectsEditDetailsStep8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports